document.addEventListener('DOMContentLoaded', () => {
  const SCROLL_DURATION = 1300;
  const SWIPE_THRESHOLD = 50; // px min
  const SWIPE_MAX_TIME = 800; // ms max
  const VERTICAL_RATIO = 1.2; // doit être plus vertical qu'horizontal

  const getSections = () =>
    Array.from(document.querySelectorAll('.js-snap-section'))
      .filter((el) => el.offsetParent !== null)
      .sort(
        (a, b) =>
          a.getBoundingClientRect().top +
          window.scrollY -
          (b.getBoundingClientRect().top + window.scrollY)
      );

  let sections = getSections();
  let isScrolling = false;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function smoothScrollTo(targetY) {
    if (isScrolling) return;

    isScrolling = true;
    const startY = window.scrollY;
    const distance = targetY - startY;
    let startTime = null;

    function animateScroll(ts) {
      if (!startTime) startTime = ts;
      const elapsed = ts - startTime;
      const progress = Math.min(elapsed / SCROLL_DURATION, 1);
      const eased = easeInOutCubic(progress);

      window.scrollTo(0, startY + distance * eased);

      if (elapsed < SCROLL_DURATION) {
        requestAnimationFrame(animateScroll);
      } else {
        isScrolling = false;
      }
    }
    requestAnimationFrame(animateScroll);
  }

  function refreshSections() {
    sections = getSections();
  }

  function getClosestSectionIndex() {
    const y = window.scrollY + window.innerHeight * 0.35;
    let closest = 0;
    let minDist = Infinity;

    sections.forEach((sec, i) => {
      const top = sec.getBoundingClientRect().top + window.scrollY;
      const dist = Math.abs(top - y);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    });
    return closest;
  }

  function isScrollableElement(el) {
    if (!el || el === document.body) return false;
    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    const canScroll =
      (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
    return canScroll || isScrollableElement(el.parentElement);
  }

  // DESKTOP / trackpad
  window.addEventListener(
    'wheel',
    (e) => {
      if (isScrolling) return;
      if (isScrollableElement(e.target)) return;
      if (Math.abs(e.deltaY) < 10) return;

      refreshSections();
      if (!sections.length) return;

      const current = getClosestSectionIndex();

      if (e.deltaY > 0 && current < sections.length - 1) {
        e.preventDefault();
        smoothScrollTo(sections[current + 1].offsetTop);
      } else if (e.deltaY < 0 && current > 0) {
        e.preventDefault();
        smoothScrollTo(sections[current - 1].offsetTop);
      }
    },
    { passive: false }
  );

  // MOBILE: swipe
  let startX = 0,
    startY = 0,
    startTime = 0;
  let moved = false;
  let locked = false;

  window.addEventListener(
    'touchstart',
    (e) => {
      if (locked || isScrolling) return;
      if (!e.touches || e.touches.length !== 1) return;
      if (isScrollableElement(e.target)) return;

      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      startTime = Date.now();
      moved = false;
    },
    { passive: true }
  );

  window.addEventListener(
    'touchmove',
    (e) => {
      if (locked || isScrolling) return;
      if (!e.touches || e.touches.length !== 1) return;
      if (isScrollableElement(e.target)) return;

      const t = e.touches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;

      // si c'est clairement un geste vertical, on peut bloquer le scroll natif
      // pour éviter l'inertie Android / iOS pendant le "snap"
      if (Math.abs(dy) > Math.abs(dx) * VERTICAL_RATIO) {
        e.preventDefault(); // nécessite passive:false
      }
    },
    { passive: false }
  );

  window.addEventListener(
    'touchend',
    (e) => {
      if (locked || isScrolling) return;
      if (!moved) return;
      if (isScrollableElement(e.target)) return;

      const elapsed = Date.now() - startTime;
      if (elapsed > SWIPE_MAX_TIME) return;

      const t = e.changedTouches && e.changedTouches[0];
      if (!t) return;

      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // on ignore les swipes plutôt horizontaux
      if (Math.abs(dy) < Math.abs(dx) * VERTICAL_RATIO) return;

      // dy < 0 => swipe up (descendre dans la page)
      if (Math.abs(dy) < SWIPE_THRESHOLD) return;

      refreshSections();
      if (!sections.length) return;

      const current = getClosestSectionIndex();

      locked = true; // évite double déclenchement avec inertie
      if (dy < 0 && current < sections.length - 1) {
        smoothScrollTo(sections[current + 1].offsetTop);
      } else if (dy > 0 && current > 0) {
        smoothScrollTo(sections[current - 1].offsetTop);
      }
      // libère le lock après la durée d'anim
      setTimeout(() => {
        locked = false;
      }, SCROLL_DURATION + 50);
    },
    { passive: true }
  );

  // Buttons
  document.querySelectorAll('[data-scroll-to]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(el.dataset.scrollTo);
      if (target) smoothScrollTo(target.offsetTop);
    });
  });
});


